exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TrophyGarden-module__wrapper___oBos7 .TrophyGarden-module__bottom___1hGG8,.TrophyGarden-module__wrapper___oBos7 .TrophyGarden-module__top___SMNLQ{position:absolute;transform:scale(.8)}.TrophyGarden-module__wrapper___oBos7 .TrophyGarden-module__top___SMNLQ{z-index:2;bottom:-230px;left:-220px}.TrophyGarden-module__wrapper___oBos7 .TrophyGarden-module__bottom___1hGG8{bottom:10px;left:-227px}", ""]);

// exports
exports.locals = {
	"wrapper": "TrophyGarden-module__wrapper___oBos7",
	"bottom": "TrophyGarden-module__bottom___1hGG8",
	"top": "TrophyGarden-module__top___SMNLQ"
};